import React, { useRef, useEffect } from 'react';
import { Box } from '@mui/material';

export default function ImagePreviewWithGrid({ 
  imageData, 
  imageTransform, 
  rows, 
  cols, 
  cellSize = 16 
}) {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!imageData || !imageData.element || !canvasRef.current) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    // Set canvas dimensions
    const chartWidth = cols * cellSize;
    const chartHeight = rows * cellSize;
    canvas.width = chartWidth;
    canvas.height = chartHeight;

    // Clear canvas
    ctx.clearRect(0, 0, chartWidth, chartHeight);

    // Draw white background
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, chartWidth, chartHeight);

    // Draw the image with current transform
    const { x, y, scale } = imageTransform;
    ctx.save();
    ctx.globalAlpha = 0.7;
    ctx.translate(x, y);
    ctx.scale(scale, scale);
    ctx.drawImage(imageData.element, 0, 0);
    ctx.restore();

    // Draw grid lines
    ctx.save();
    ctx.strokeStyle = 'rgba(0, 0, 0, 0.4)';
    ctx.lineWidth = 1;

    // Vertical lines
    for (let col = 0; col <= cols; col++) {
      const lineX = col * cellSize;
      ctx.beginPath();
      ctx.moveTo(lineX, 0);
      ctx.lineTo(lineX, chartHeight);
      ctx.stroke();
    }

    // Horizontal lines
    for (let row = 0; row <= rows; row++) {
      const lineY = row * cellSize;
      ctx.beginPath();
      ctx.moveTo(0, lineY);
      ctx.lineTo(chartWidth, lineY);
      ctx.stroke();
    }

    // Thick lines every 5 cells for better visibility
    ctx.strokeStyle = 'rgba(0, 0, 0, 0.7)';
    ctx.lineWidth = 2;

    // Thick vertical lines
    for (let col = 0; col <= cols; col += 5) {
      const lineX = col * cellSize;
      ctx.beginPath();
      ctx.moveTo(lineX, 0);
      ctx.lineTo(lineX, chartHeight);
      ctx.stroke();
    }

    // Thick horizontal lines
    for (let row = 0; row <= rows; row += 5) {
      const lineY = row * cellSize;
      ctx.beginPath();
      ctx.moveTo(0, lineY);
      ctx.lineTo(chartWidth, lineY);
      ctx.stroke();
    }

    ctx.restore();
  }, [imageData, imageTransform, rows, cols, cellSize]);

  if (!imageData || !imageData.element) {
    return null;
  }

  const chartWidth = cols * cellSize;
  const chartHeight = rows * cellSize;

  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'center', 
      mb: 2,
      p: 1,
      border: '1px solid #ddd',
      borderRadius: 1,
      bgcolor: 'background.default'
    }}>
      <canvas
        ref={canvasRef}
        style={{
          maxWidth: '100%',
          maxHeight: '300px',
          objectFit: 'contain',
          border: '1px solid #ccc'
        }}
        width={chartWidth}
        height={chartHeight}
      />
    </Box>
  );
}
